import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconMedication.tsx
const OutlinedFilledMedication = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M440-250h79v-113h116v-80H519v-113h-79v113H325v80h115v113ZM260-68q-38.78 0-66.39-27.91Q166-123.81 166-163v-479q0-38.77 27.61-66.39Q221.22-736 260-736h440q39.19 0 67.09 27.61Q795-680.77 795-642v479q0 39.19-27.91 67.09Q739.19-68 700-68H260Zm-43-729v-95h527v95H217Z" })
});
const OutlinedMedication = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M440-252h79v-111h114v-80H519v-111h-79v111H327v80h113v111ZM260-68q-38.78 0-66.39-27.91Q166-123.81 166-163v-479q0-38.77 27.61-66.39Q221.22-736 260-736h440q39.19 0 67.09 27.61Q795-680.77 795-642v479q0 39.19-27.91 67.09Q739.19-68 700-68H260Zm0-95h440v-479H260v479Zm-43-634v-95h527v95H217Zm43 155v479-479Z" })
});
const RoundedFilledMedication = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M440-363v80q0 16.67 11.74 28.33Q463.47-243 480.24-243q16.76 0 28.26-11.67Q520-266.33 520-283v-80h80q16.67 0 28.33-11.74 11.67-11.73 11.67-28Q640-419 628.33-431q-11.66-12-28.33-12h-80v-80q0-15.67-11.74-27.83Q496.53-563 479.76-563q-16.76 0-28.26 12.17Q440-538.67 440-523v80h-80q-16.67 0-28.33 12.24Q320-418.53 320-402.26q0 16.26 11.67 27.76Q343.33-363 360-363h80ZM260-68q-38.78 0-66.39-27.91Q166-123.81 166-163v-479q0-38.77 27.61-66.39Q221.22-736 260-736h440q39.19 0 67.09 27.61Q795-680.77 795-642v479q0 39.19-27.91 67.09Q739.19-68 700-68H260Zm4-729q-19.75 0-33.37-13.68-13.63-13.67-13.63-34 0-20.32 13.63-33.82Q244.25-892 264-892h432q19.75 0 33.38 13.68 13.62 13.67 13.62 34 0 20.32-13.62 33.82Q715.75-797 696-797H264Z" })
});
const RoundedMedication = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M440-363v72q0 17 11.74 28 11.73 11 28.5 11Q497-252 508-263.67q11-11.66 11-28.33v-71h74q16.67 0 28.33-11.74 11.67-11.73 11.67-28Q633-419 621.33-431q-11.66-12-28.33-12h-74v-72q0-16-11-27.5T480.24-554q-16.77 0-28.5 11.5Q440-531 440-515v72h-73q-16.67 0-28.33 12.24Q327-418.53 327-402.26q0 16.26 11.67 27.76Q350.33-363 367-363h73ZM260-68q-38.78 0-66.39-27.91Q166-123.81 166-163v-479q0-38.77 27.61-66.39Q221.22-736 260-736h440q39.19 0 67.09 27.61Q795-680.77 795-642v479q0 39.19-27.91 67.09Q739.19-68 700-68H260Zm0-95h440v-479H260v479Zm4-634q-19.75 0-33.37-13.68-13.63-13.67-13.63-34 0-20.32 13.63-33.82Q244.25-892 264-892h433q19.75 0 33.38 13.68 13.62 13.67 13.62 34 0 20.32-13.62 33.82Q716.75-797 697-797H264Zm-4 155v479-479Z" })
});
const SharpFilledMedication = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M440-243h80v-120h120v-80H520v-120h-80v120H320v80h120v120ZM166-68v-668h629v668H166Zm51-729v-95h526v95H217Z" })
});
const SharpMedication = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M440-252h79v-111h114v-80H519v-111h-79v111H327v80h113v111ZM166-68v-668h629v668H166Zm94-95h440v-479H260v479Zm-43-634v-95h527v95H217Zm43 155v479-479Z" })
});
const componentMap = {
	outlined: OutlinedMedication,
	"outlined-fill": OutlinedFilledMedication,
	rounded: RoundedMedication,
	"rounded-fill": RoundedFilledMedication,
	sharp: SharpMedication,
	"sharp-fill": SharpFilledMedication
};
const IconMedication = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconMedication };